import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-register-terms',
  templateUrl: 'register-terms.html',
})
export class RegisterTermsPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RegisterTermsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/register-terms/register-terms.ts